import { Fuel, Leaf, Receipt } from "lucide-react";

// Low-running-cost highlight for listings that opt in (e.g. first cars), using the figures entered in Admin.
export function RunningCosts({ v }) {
  const items = [[Receipt, "Road tax", v.road_tax], [Fuel, "Economy", v.mpg && `${v.mpg}${/mpg/i.test(v.mpg) ? "" : " mpg"}`], [Leaf, "CO2", v.co2]].filter(([, , val]) => val);
  if (!v.show_running_costs || items.length === 0) return null;
  return (
    <div className="mt-6 border border-forest/30 bg-forest/5 p-4" data-testid="running-costs">
      <p className="eyebrow text-forest">Low running costs</p>
      <dl className="mt-3 grid grid-cols-3 gap-3">
        {items.map(([Icon, k, val]) => (
          <div key={k}>
            <Icon className="h-4 w-4 text-forest" strokeWidth={1.5} />
            <dt className="mt-1 text-[0.68rem] uppercase tracking-[0.14em] text-charcoal/70">{k}</dt>
            <dd className="text-sm font-semibold" data-testid={`running-cost-${k.toLowerCase().replace(/\s+/g, "-")}`}>{val}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
